import { List } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { IndexListItem } from 'components/styles_components/list';
import ListItem from 'components/space_users/index/list_item';
import ListHeader from 'components/space_users/index/list_header';
import LoaderContainer from 'components/layout/loader_container';
import InfoContainer from 'components/info_container';

const Index = ({ permissions, onRemove, sortBy, onSortChange, loading }) => {
  return (
    <List>
      <ListHeader sortBy={sortBy} onSortChange={onSortChange} />
      <LoaderContainer loading={loading} wrap={false} keepRenderedContent={true}>
        {permissions.map((permission) => (
          <ListItem key={permission.id} permission={permission} onRemove={onRemove} />
        ))}
      </LoaderContainer>
      {!loading && permissions.length === 0 && (
        <IndexListItem>
          <InfoContainer>
            <FormattedMessage id="empty.users.title" />
          </InfoContainer>
        </IndexListItem>
      )}
    </List>
  );
};

export default Index;
